export const setCookie = (name, value, expires = 400) => {
    if (!Cookies2) {
        return false;
    }

    Cookies2.set(name, value, {expires});
    return true;
}

export const getCookie = (name) => {
    if (!Cookies2) {
        return null;
    }

    return Cookies2.get(name);
}

export const removeCookie = (name) => {
    if (!Cookies2) {
        return null;
    }

    return Cookies2.remove(name);
}
